import React from "react";

import {
  NotFoundContainer,
  NotFoundTitle,
  NotFoundText,
  HomeButton,
  ImageStyled,
} from "./styles";

const NotFoundPage: React.FC = () => {
  return (
    <NotFoundContainer>
      <ImageStyled src="/assets/app-icon-no-bg-small.png" alt="Windows" />
      <NotFoundTitle>404</NotFoundTitle>
      <NotFoundText>The page you're looking for doesn't exist.</NotFoundText>
      <HomeButton to="/">Go Home</HomeButton>
    </NotFoundContainer>
  );
};

export default NotFoundPage;
